const eduCampMixin = {
	data: () => ({
		urlParams: null,
		eduEmail: null,
	}),
	created() {
		// drip, utm 파라미터 가져오기
		this.urlParams = this.$_getUrlParams();
		this.eduEmail = this.userId;
		const sessionEduEmail = this.$_getSessionStorage('eduEmail');

		let { drip_email } = this.urlParams;
		if (this.eduEmail === '-1') {
			if (typeof drip_email !== 'undefined') {
				// url에 drip_email이 있으면 sessionStorage에 넣기
				this.eduEmail = drip_email;
				this.$_setSessionStorage('eduEmail', this.eduEmail);
			} else if (sessionEduEmail) {
				// sessionStorage에 이메일이 있으면 eduEmail로 저장
				this.eduEmail = sessionEduEmail;
			}
		}
	},
	methods: {
		$_detail(url, no, _blank) {
			if (typeof this.page !== 'undefined') {
				const isRecommendCamp = this.name === 'recommend-camp';
				if (isRecommendCamp) {
					this.$_removeSessionStorage('state_edu_camp_list');
				} else {
					let eduCampList = this.$_getSessionStorage('state_edu_camp_list') || {};
					eduCampList.campList = this.campList;
					eduCampList.page = this.page;
					eduCampList.count = this.count;
					eduCampList.no = no;
					eduCampList.keyword = this.storeKeyword;
					this.$_setSessionStorage('state_edu_camp_list', eduCampList);
				}
			}
			if (_blank) {
				window.open(url);
			} else {
				location.href = url;
			}
		},
		$_campLocation(channel, location) {
			let result = '온라인';

			if (channel !== 'online') {
				const locationArr = location.split(',');
				const locationLastItem = locationArr.slice(-1).pop();
				result = locationLastItem.trim();
			}

			return result;
		},
		$_isEarlyCamp(campPrice) {
			// 가격이 24만원 미만일 때
			return campPrice < 240000;
		},
		$_printInternOrCamp(eduCurrent) {
			let text = '인턴';
			if (eduCurrent && parseInt(eduCurrent) === 1) {
				text = '캠프';
			}
			return text;
		},
		$_printEncoreCampTitle(title, round) {
			let campTitle = title;
			if (round > 1) {
				campTitle = `[${round}차 앵콜] ${campTitle}`;
			}
			return campTitle;
		},
		$_isEndCamp(running, partnerName) {
			return running === 0 && partnerName === 'comento';
		},
		$_isNineWeekCampTitle(title) {
			if (title) {
				return title.includes('[9주 심화반]');
			}
			return false;
		},
	},
};

export default eduCampMixin;
